import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";

type UploadModalProps = {
  modalButton: string;
  modalHeader: string;
  label: string;
  helperText: string;
  sendButton: string;
  onDataUploaded: (file: File) => void;
};

const UploadModal = (props: UploadModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleClick() {
    if (file) {
      props.onDataUploaded(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        {props.modalButton}
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.modalHeader}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>{props.label}</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                {props.helperText}
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!file}
              onClick={handleClick}
            >
              {props.sendButton}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UploadModal;
